module.exports = __webpack_public_path__ + "media/images/03-551679d1be579cc177208f8be6ea72c3.jpg";